import {ChangeDetectorRef, Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {OrderEntry} from '@spartacus/cart/base/root/models/cart.model';
import {DcpOrderEntryService} from '@app/services/dcp-order-entry.service';
import {DcpPriceCalculationBreakdown} from '@dcp/configurator';
import {DcpConfigService} from '@app/services/dcp-config.service';
import {TransactionTypeService} from '@app/services/transactionTypes/transaction-type.service';
import {Observable, first} from 'rxjs';
import {DefaultModalService} from '@app/shared/modal/services/default-modal.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {TranslationService} from '@spartacus/core';
import {TransactionTypeTexts} from '@app/checkout/order-confirmation/order-confirmation-list-item/order-confirmation-order-item.model';

interface PricePerLicenseData {
  name?: string;
  pricePer?: string;
}

@UntilDestroy()
@Component({
  selector: 'dcp-price-details-tooltip',
  templateUrl: './price-details-tooltip.component.html',
  styleUrls: ['./price-details-tooltip.component.scss']
})
export class PriceDetailsTooltipComponent implements OnInit {
  @Input() entry: OrderEntry;
  @Input() derivativeCount: number = 0;
  @Input() showPricingTooltip: boolean = false;
  @ViewChild('modalContentTemplate') modalContentTemplate: TemplateRef<any>;
  pricePerLicenseData: PricePerLicenseData = null;
  priceCalculationBreakdownData: DcpPriceCalculationBreakdown[] = null;
  $transactionTypeTexts: Observable<TransactionTypeTexts>;
  modalTitleKey: string = 'cartItems.priceTooltip.header';
  modalTitleValue: string;
  modalId: string;

  constructor(
    public dcpOrderEntryService: DcpOrderEntryService,
    public dcpConfigService: DcpConfigService,
    public changeDetection: ChangeDetectorRef,
    private transactionTypeService: TransactionTypeService,
    private modalService: DefaultModalService,
    private translationService: TranslationService,
  ) {
  }

  ngOnInit(): void {
    this.setupModalData();
  }

  openPriceDisplayModal(): void {
    this.translationService.translate(this.modalTitleKey)
      .pipe(first(), untilDestroyed(this))
      .subscribe((translation) => {
        this.modalTitleValue = translation;
    });
    this.modalId = this.modalService.openModal(this.modalContentTemplate, this.modalTitleValue);
  }

  closePriceDisplayModal(): void {
    this.modalService.closeModal(this.modalId);
  }

  setupModalData(): void {
    this.priceCalculationBreakdownData = this.dcpOrderEntryService.getPriceCalculationBreakdown(this.entry);
    const priceDetailsData: any = this.dcpOrderEntryService.getPriceDetails(this.entry);
    if (priceDetailsData) {
      this.pricePerLicenseData = this.setupPricePerLicenseData(priceDetailsData, this.entry);
    }
    const transactionTypeCode: string = this.transactionTypeService.getTransactionTypeCodeByUrlOrOrderEntry(this.entry);
    this.$transactionTypeTexts = this.transactionTypeService.getTranslations(transactionTypeCode);
  }

  setupPricePerLicenseData(priceDetailsData: any, entry: OrderEntry): PricePerLicenseData {
    return {
      name: `${entry.product.name} (${entry.product.supplierAlternativeAID})`,
      pricePer: `${priceDetailsData.formattedValues.netPricePerMonth}`,
    };
  }
}
